import { AxiosResponse } from "axios";
import { OrganizationKeyName } from "../../../model/Organization";
import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../model/http-crud-models";
import {
  MutatePaymentProviderConfigurationPayload,
  PaymentProvider,
  PaymentProviderConfiguration,
} from "../models/payment-provider-configuration";
import { httpClient } from "../../../service/http";

export const paymentProviderConfigurationsHttp = {
  createPaymentProviderConfiguration: async ({
    organizationKeyName,
    data,
  }: PostPayload<MutatePaymentProviderConfigurationPayload>): Promise<string> => {
    const res = await httpClient<{ id: string }>({
      method: "POST",
      url: `/management/organizations/${organizationKeyName}/provider-configurations/items`,
      data,
    });
    return res.id;
  },

  updatePaymentProviderConfiguration: ({
    organizationKeyName,
    data: { id, ...rest },
  }: PutPayload<MutatePaymentProviderConfigurationPayload>): Promise<AxiosResponse> => {
    return httpClient({
      method: "PUT",
      url: `/management/organizations/${organizationKeyName}/provider-configurations/items/${id}`,
      data: rest,
    });
  },

  getPaymentProviderConfigurations: async (
    organizationKeyName: OrganizationKeyName
  ) => {
    return httpClient<PaymentProviderConfiguration[]>({
      method: "GET",
      url: `/management/organizations/${organizationKeyName}/provider-configurations/items`,
    });
  },

  getPaymentProviderConfiguration: async (
    organizationKeyName: OrganizationKeyName,
    id?: string
  ) => {
    return httpClient<PaymentProviderConfiguration>({
      method: "GET",
      url: `/management/organizations/${organizationKeyName}/provider-configurations/items/${id}`,
    });
  },

  getPaymentProviders: async (organizationKeyName: OrganizationKeyName) => {
    return httpClient<PaymentProvider[]>({
      method: "GET",
      url: `/management/organizations/${organizationKeyName}/payment-providers`,
    });
  },

  deletePaymentProviderConfiguration: async ({
    organizationKeyName,
    data: { id },
  }: DeletePayload): Promise<string> => {
    const res = await httpClient<{ id: string }>({
      method: "DELETE",
      url: `/management/organizations/${organizationKeyName}/provider-configurations/items/${id}`,
    });
    return res.id;
  },
};
